var _defs, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgYoutube(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 62.505,
    height: 62.505,
    viewBox: "0 0 62.505 62.505",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_2081",
    "data-name": "Rectangle 2081",
    width: 38.717,
    height: 27.418
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2464",
    "data-name": "Groupe 2464",
    transform: "translate(-782.574 -710.5)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2904",
    "data-name": "Trac\\xE9 2904",
    d: "M61.5,30.753A30.752,30.752,0,1,1,30.753,0,30.752,30.752,0,0,1,61.5,30.753",
    transform: "translate(783.074 710.999)",
    fill: "none",
    stroke: "#000",
    strokeWidth: 1,
    fillRule: "evenodd"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2471",
    "data-name": "Groupe 2471",
    transform: "translate(794.468 728.043)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Groupe_2467",
    "data-name": "Groupe 2467",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Trac\\xE9_2936",
    "data-name": "Trac\\xE9 2936",
    d: "M38.265,6.026C37.662,1.582,35.4.83,30.959.452,29.038.3,26.986.189,24.988.113S21.052,0,19.358,0c-3.39,0-7.834.151-11.6.452C3.314.83.979,1.582.376,6.026.264,7.043.169,8.248.1,9.557S0,12.278,0,13.709a72.8,72.8,0,0,0,.376,7.684c.6,4.518,2.938,5.2,7.382,5.573,1.883.189,3.935.3,5.941.367s3.964.085,5.659.085c3.39,0,7.76-.076,11.6-.452,4.444-.376,6.7-1.055,7.306-5.573.15-.979.263-2.185.339-3.5s.113-2.75.113-4.181a56.306,56.306,0,0,0-.452-7.683M15.441,19.584V7.909l10.094,5.8Z",
    fillRule: "evenodd"
  }))))));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgYoutube);
export default __webpack_public_path__ + "static/media/youtube.42b66a48271785141f686029c540f181.svg";
export { ForwardRef as ReactComponent };